<app-local-trends></app-local-trends>
<div class="body_wrap overflowHidden">
  <!-- <div class="sticky-top sticky-offset"> -->
  <!-- <div class="top_menu" [ngClass]="{ 'pl-0': !isHamburger }"> -->
  <!-- <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button> -->
  <!-- <app-search></app-search>
      <app-search-agent> </app-search-agent>
      <app-view-search class="saved-popup"></app-view-search> -->
  <!-- </div> -->
  <!-- </div> -->
  <div class="dash_base" [ngClass]="isCompanyNavActive ? appState.companyInfoValue.alias : ''">
    <!-- <app-active-filter class="filter_base"></app-active-filter> -->
    <div>
      <app-property-filter-bar
        class="filter_base"
        [joyrideStep]="'presetFilter'"
        [title]="'Spot Investment Deals in Seconds'"
        text="Quickly surface high-potential investment opportunities using preset filters like foreclosures, multi-family, and off-market signals. Skip the noise and focus on properties that align with your investment strategy—so you can identify deals faster and act before others do.
"
      ></app-property-filter-bar>
    </div>

    <router-outlet></router-outlet>
  </div>
</div>

<app-all-filter-sheet [applyToUrl]="true"></app-all-filter-sheet>
